// components/Dashboard/tabs/platforms/TelegramChannels.js
import React, { useState, useEffect } from 'react';
import ChannelHistoryModal from '../../../Modals/ChannelHistoryModal/ChannelHistoryModal';
import API_URL from '../../../../config';
import ChannelForwardModal from '../../../Modals/ChannelForwardModal/ChannelForwardModal';

const TelegramChannels = ({
  channels,
  channelStats,
  loadingStats,
  mtprotoStatus,
  onAddChannel,
  onEditChannel,
  onDeleteChannel,
  onFetchChannelStats,
  onRefreshChannels,
  showMessage,
  BASE_URL,
  onNavigateToLibrary,
  onNavigateToAutomation // ✅ YENİ PROP
}) => {

  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedChannelForHistory, setSelectedChannelForHistory] = useState(null);
  const [automationRules, setAutomationRules] = useState([]);
  const [tags, setTags] = useState([]);
  const [showForwardModal, setShowForwardModal] = useState(false);
  const [selectedChannelForForward, setSelectedChannelForForward] = useState(null);

  // Otomasyon kurallarını ve etiketleri çek
  useEffect(() => {
    fetchAutomationRules();
    fetchTags();
  }, []);

  const fetchAutomationRules = async () => {
    try {
      const response = await fetch(`${API_URL}/automation`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const data = await response.json();
      if (data.success) {
        setAutomationRules(data.rules || []);
      }
    } catch (error) {
      console.error('Otomasyon kuralları yüklenemedi:', error);
    }
  };

  // Etiketleri çek
  const fetchTags = async () => {
    try {
      const response = await fetch(`${API_URL}/tags`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const data = await response.json();
      if (data.success) {
        setTags(data.tags || []);
      }
    } catch (error) {
      console.error('Etiketler yüklenemedi:', error);
    }
  };

  // Otomatik paylaşım modal'ını aç
  const handleOpenForwardModal = (channel, e) => {
    e.stopPropagation();
    setSelectedChannelForForward(channel);
    setShowForwardModal(true);
  };

  const handleAutomationClick = (channelId, e) => {
    e.stopPropagation();

    console.log('🔍 Otomasyon tıklandı, channelId:', channelId);
    console.log('🔍 Mevcut otomasyon kuralları:', automationRules);

    // Bu kanala ait aktif otomasyonu bul
    const channelAutomation = automationRules.find(rule => {
      const channelIds = rule.channel_ids ? rule.channel_ids.split(',').map(id => id.trim()) : [];
      const hasChannel = channelIds.includes(String(channelId));
      console.log('🔍 Kural kontrol:', rule.id, channelIds, hasChannel, rule.is_active);
      return hasChannel && rule.is_active === 1;
    });

    console.log('🔍 Bulunan otomasyon:', channelAutomation);

    if (channelAutomation && onNavigateToAutomation) {
      console.log('✅ Yönlendirme yapılıyor, automationId:', channelAutomation.id);
      onNavigateToAutomation(channelAutomation.id);
    } else {
      console.log('❌ Otomasyon bulunamadı veya onNavigateToAutomation tanımlı değil');
    }
  };

  // Kanalın aktif otomasyon etiketlerini bul
  const getChannelActiveAutomationTags = (channelId) => {
    const channelRules = automationRules.filter(rule => {
      const channelIds = rule.channel_ids ? rule.channel_ids.split(',').map(id => id.trim()) : [];
      return channelIds.includes(String(channelId)) && rule.is_active === 1;
    });

    // Tüm tag isimlerini topla (tags string olarak geliyor)
    let allTagNames = [];
    channelRules.forEach(rule => {
      if (rule.tags) {
        const tagNames = rule.tags.split(',').map(tag => tag.trim());
        allTagNames = [...allTagNames, ...tagNames];
      }
    });

    // Benzersiz tag isimlerini al
    const uniqueTagNames = [...new Set(allTagNames)];

    // Tag bilgilerini eşleştir (isim üzerinden)
    const activeTags = uniqueTagNames.map(tagName => {
      return tags.find(tag => tag.name.toLowerCase() === tagName.toLowerCase());
    }).filter(Boolean);

    return activeTags;
  };

  // Etiket tıklama handler
  const handleTagClick = (tagId, e) => {
    e.stopPropagation();
    if (onNavigateToLibrary) {
      onNavigateToLibrary(tagId);
    }
  };

  // Kanalın otomasyon zamanlarını bul
  const getChannelAutomationSchedule = (channelId) => {
    const channelRules = automationRules.filter(rule => {
      const channelIds = rule.channel_ids ? rule.channel_ids.split(',').map(id => id.trim()) : [];
      return channelIds.includes(String(channelId)) && rule.is_active === 1;
    });

    if (channelRules.length === 0) return null;

    // TÜM KURALLARIN SAATLERİNİ BİRLEŞTİR
    let allTimes = [];

    channelRules.forEach(rule => {
      if (rule.daily_times) {
        try {
          const times = JSON.parse(rule.daily_times);
          if (Array.isArray(times) && times.length > 0) {
            allTimes = [...allTimes, ...times];
          }
        } catch (e) {
          console.error('daily_times parse error:', e);
        }
      }
    });

    // Saatleri sırala
    allTimes.sort((a, b) => {
      if (a.hour !== b.hour) return a.hour - b.hour;
      return a.minute - b.minute;
    });

    // Duplicate saatleri kaldır
    const uniqueTimes = allTimes.filter((time, index, self) =>
      index === self.findIndex(t => t.hour === time.hour && t.minute === time.minute)
    );

    // En yakın saati bul
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();

    let nextTimeIndex = uniqueTimes.findIndex(t =>
      t.hour > currentHour ||
      (t.hour === currentHour && t.minute > currentMinute)
    );

    // Bugün için saat yoksa yarının ilk saati
    if (nextTimeIndex === -1 && uniqueTimes.length > 0) {
      nextTimeIndex = 0;
    }

    return {
      allTimes: uniqueTimes,
      nextTimeIndex: nextTimeIndex,
      rulesCount: channelRules.length
    };
  };

  const handleRefreshAll = async () => {
    showMessage('🔄 Tüm kanallar yenileniyor...', 'info');
    await onRefreshChannels();
    await fetchAutomationRules();
    await fetchTags();

    if (mtprotoStatus?.connected) {
      for (const channel of channels) {
        await onFetchChannelStats(channel.id);
        await new Promise(resolve => setTimeout(resolve, 500));
      }
    }

    showMessage('✅ Tüm kanallar güncellendi!', 'success');
  };

  const handleShowHistory = (channel) => {
    setSelectedChannelForHistory(channel);
    setShowHistoryModal(true);
  };

  const handleEditChannel = (channel) => {
    const photoUrl = channel.profile_photo
      ? `${BASE_URL}/uploads/${channel.profile_photo}`
      : null;

    onEditChannel({
      ...channel,
      photo_url: photoUrl
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Az önce';
    if (diffMins < 60) return `${diffMins} dakika önce`;
    if (diffHours < 1) return `${diffMins} dakika önce`;
    if (diffHours < 24) return `${diffHours} saat önce`;
    if (diffDays === 1) return 'Dün';
    if (diffDays < 7) return `${diffDays} gün önce`;

    return date.toLocaleDateString('tr-TR', {
      day: 'numeric',
      month: 'short',
      year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
    });
  };

  const formatLastUpdate = (dateString) => {
    if (!dateString) return 'Güncellenmemiş';

    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffDays === 0) {
      if (diffMins < 1) return 'Şimdi güncellendi';
      if (diffMins < 60) return `${diffMins} dk önce güncellendi`;
      return `Bugün ${date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}`;
    }

    if (diffDays === 1) {
      return `Dün ${date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}`;
    }

    if (diffDays < 7) {
      return `${diffDays} gün önce`;
    }

    return date.toLocaleDateString('tr-TR', {
      day: 'numeric',
      month: 'short',
      year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
    });
  };

  return (
    <div className="ct-telegram-channels-container">
      <div className="ct-channels-list">
        {channels.length === 0 ? (
          <p>Henüz kanal eklenmemiş.</p>
        ) : (
          <div className="ct-channels-grid">
            {[...channels]
              .sort((a, b) => {
                const aSubscribers = channelStats[a.id]?.subscriberCount || a.member_count || 0;
                const bSubscribers = channelStats[b.id]?.subscriberCount || b.member_count || 0;
                return bSubscribers - aSubscribers;
              })
              .map(channel => {
                const automationData = getChannelAutomationSchedule(channel.id);
                const activeTags = getChannelActiveAutomationTags(channel.id);

                return (
                  <div key={channel.id} className="ct-channel-card">
                    <div className="ct-channel-card-content">
                      {channel.last_post_time && (
                        <div className="ct-last-post-badge">
                          <span>⏰</span>
                          {(() => {
                            const postDate = new Date(channel.last_post_time);
                            const now = new Date();
                            const diffMs = now - postDate;
                            const diffMins = Math.floor(diffMs / 60000);
                            const diffHours = Math.floor(diffMs / 3600000);
                            const diffDays = Math.floor(diffMs / 86400000);

                            if (diffMins < 1) return 'Şimdi';
                            if (diffMins < 60) return `${diffMins} dk önce`;
                            if (diffHours < 24) return postDate.toLocaleTimeString('tr-TR', {
                              hour: '2-digit',
                              minute: '2-digit'
                            });
                            if (diffDays === 1) return `Dün ${postDate.toLocaleTimeString('tr-TR', {
                              hour: '2-digit',
                              minute: '2-digit'
                            })}`;
                            if (diffDays < 7) return postDate.toLocaleDateString('tr-TR', {
                              weekday: 'short',
                              hour: '2-digit',
                              minute: '2-digit'
                            });
                            return postDate.toLocaleDateString('tr-TR', {
                              day: 'numeric',
                              month: 'short',
                              hour: '2-digit',
                              minute: '2-digit'
                            });
                          })()}
                        </div>
                      )}

                      <div className="ct-channel-header-section">
                        <div className="ct-channel-main-info">
                          <div className="ct-channel-avatar">
                            {channel.profile_photo ? (
                              <img
                                src={`${BASE_URL}/uploads/${channel.profile_photo}`}
                                alt={channel.name}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                }}
                              />
                            ) : (
                              <>
                                {channel.name ? channel.name.charAt(0).toUpperCase() : '📡'}
                                {mtprotoStatus?.connected && (
                                  <button
                                    className="ct-fetch-photo-mini-btn"
                                    onClick={async (e) => {
                                      e.stopPropagation();
                                      const response = await fetch(`${BASE_URL}/api/channels/${channel.id}/fetch-photo`, {
                                        method: 'POST',
                                        headers: {
                                          'Authorization': `Bearer ${localStorage.getItem('token')}`
                                        }
                                      });

                                      const data = await response.json();
                                      if (data.success) {
                                        showMessage('✅ Fotoğraf güncellendi', 'success');
                                        onRefreshChannels();
                                      } else {
                                        showMessage('❌ ' + data.message, 'error');
                                      }
                                    }}
                                    title="Fotoğrafı Telegram'dan çek"
                                  >
                                    📸
                                  </button>
                                )}
                              </>
                            )}
                          </div>

                          <div className="ct-channel-details">
                            <h4>
                              <span
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  gap: '8px'
                                }}
                              >
                                <span
                                  onClick={() => handleEditChannel(channel)}
                                  className="ct-channel-name-clickable"
                                  style={{
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    color: '#2c3e50',
                                    fontWeight: '600'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.color = '#667eea';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.color = '#2c3e50';
                                  }}
                                  title="Düzenlemek için tıklayın"
                                >
                                  {channel.name}
                                </span>

                                {(() => {
                                  let telegramUrl = '';

                                  if (channel.username) {
                                    telegramUrl = `https://t.me/${channel.username.replace('@', '')}`;
                                  } else if (channel.chat_id) {
                                    if (channel.chat_id.startsWith('@')) {
                                      telegramUrl = `https://t.me/${channel.chat_id.replace('@', '')}`;
                                    } else if (channel.chat_id.startsWith('-')) {
                                      telegramUrl = `https://web.telegram.org/k/#${channel.chat_id}`;
                                    }
                                  }

                                  if (telegramUrl) {
                                    return (
                                      <a
                                        href={telegramUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ct-telegram-link-icon"
                                        onClick={(e) => e.stopPropagation()}
                                        title="Telegram'da aç"
                                        style={{
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          width: '20px',
                                          height: '20px',
                                          color: '#5a9fd4',
                                          transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.color = '#4a8fc4';
                                          e.currentTarget.style.transform = 'scale(1.1)';
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.color = '#5a9fd4';
                                          e.currentTarget.style.transform = 'scale(1)';
                                        }}
                                      >
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                          <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3" />
                                        </svg>
                                      </a>
                                    );
                                  }
                                  return null;
                                })()}

                                {channel.type === 'private' && (
                                  <span className="ct-private-badge" style={{
                                    fontSize: '12px',
                                    padding: '2px 6px',
                                    background: 'rgba(0, 0, 0, 0.1)',
                                    borderRadius: '4px'
                                  }}>
                                    🔒 Private
                                  </span>
                                )}
                              </span>
                            </h4>

                            <div className="ct-channel-meta">
                              {channel.username && (
                                <a
                                  href={`https://t.me/${channel.username.replace('@', '')}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="ct-channel-username"
                                >
                                  @{channel.username.replace('@', '')}
                                </a>
                              )}

                              {(channelStats[channel.id]?.subscriberCount || channel.member_count) > 0 && (
                                <span className="ct-channel-members">
                                  <span>•</span>
                                  👥 {(channelStats[channel.id]?.subscriberCount || channel.member_count || 0).toLocaleString('tr-TR')} üye
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {channel.description && (
                        <p className="ct-channel-description">
                          "{channel.description}"
                        </p>
                      )}

                      {/* ✅ OTOMASYON BİLGİSİ - TIKLANABILIR YAPILDI */}
                      {automationData && automationData.allTimes.length > 0 ? (
                        <div
                          className="ct-channel-automation-info"
                          onClick={(e) => handleAutomationClick(channel.id, e)}
                          style={{
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                          }}
                          title="Otomasyonu düzenlemek için tıklayın"
                        >
                          <div
                            className="ct-automation-schedule-badge"
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = 'rgba(16, 185, 129, 0.1)';
                              e.currentTarget.style.transform = 'translateY(-1px)';
                              e.currentTarget.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '';
                              e.currentTarget.style.transform = '';
                              e.currentTarget.style.boxShadow = '';
                            }}
                            style={{
                              transition: 'all 0.2s ease',
                              borderRadius: '8px',
                              padding: '8px'
                            }}
                          >
                            <span className="ct-schedule-icon">🤖</span>
                            <div className="ct-schedule-details" style={{ flex: 1 }}>
                              <span className="ct-schedule-text">
                                Her gün {automationData.allTimes.length} kez
                                {automationData.rulesCount > 1 && ` (${automationData.rulesCount} kural)`}
                              </span>
                              <div className="ct-schedule-times-preview" style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '4px',
                                marginTop: '4px',
                                width: '100%'
                              }}>
                                {automationData.allTimes.map((time, index) => {
                                  const isNextTime = index === automationData.nextTimeIndex;

                                  return (
                                    <span
                                      key={`${time.hour}-${time.minute}`}
                                      className="ct-time-preview"
                                      style={{
                                        padding: '2px 6px',
                                        background: isNextTime ? '#10B98115' : 'rgba(0, 0, 0, 0.05)',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        color: isNextTime ? '#10B981' : '#666',
                                        fontWeight: isNextTime ? 'bold' : 'normal',
                                        border: isNextTime ? '1px solid #10B981' : '1px solid transparent',
                                        display: 'inline-block'
                                      }}
                                    >
                                      {String(time.hour).padStart(2, '0')}:{String(time.minute).padStart(2, '0')}
                                    </span>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="ct-channel-automation-info ct-inactive">
                          <span className="ct-no-automation">
                            🔕 Otomasyon yok
                          </span>
                        </div>
                      )}

                      {channel.channel_tags && channel.channel_tags.length > 0 && (
                        <div className="ct-channel-tags">
                          {channel.channel_tags.map(tag => (
                            <span
                              key={tag.id}
                              className="ct-channel-tag"
                              style={{ backgroundColor: tag.color }}
                            >
                              {tag.name}
                            </span>
                          ))}
                        </div>
                      )}

                      {/* ABONE SAYISI YERİNE AKTİF OTOMASYON ETİKETLERİ */}
                      <div className="ct-channel-stats-section">
                        {activeTags.length > 0 ? (
                          <div className="content-tags-wrapper" style={{
                            width: '100%',
                            overflow: 'hidden'
                          }}>
                            <div className="content-tags" style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: '6px',
                              maxWidth: '100%'
                            }}>
                              {activeTags.map(tag => (
                                <span
                                  key={tag.id}
                                  className="content-tag-badge"
                                  onClick={(e) => handleTagClick(tag.id, e)}
                                  style={{
                                    backgroundColor: tag.color,
                                    color: '#fff',
                                    padding: '4px 8px',
                                    borderRadius: '12px',
                                    fontSize: '11px',
                                    fontWeight: '500',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '3px',
                                    transition: 'all 0.2s ease',
                                    border: '1px solid transparent',
                                    maxWidth: '130px',
                                    overflow: 'hidden',
                                    flexShrink: 0
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = 'none';
                                  }}
                                  title={`${tag.name} etiketli içerikleri görüntüle`}
                                >
                                  <span style={{ flexShrink: 0 }}>🏷️</span>
                                  <span style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                  }}>
                                    {tag.name}
                                  </span>
                                </span>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <div className="ct-no-active-tags">
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="ct-card-footer-info">
                      <div className="ct-footer-left">
                        <span className="ct-footer-username">
                          {channel.created_by_username || 'Sistem'}
                        </span>
                      </div>

                      <div className="ct-footer-actions" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span className="ct-footer-date" title={`Son güncellenme: ${new Date(channel.updated_at || channel.created_at).toLocaleString('tr-TR')}`} style={{ fontSize: '11px', color: '#9ca3af', marginRight: '4px' }}>
                          {formatLastUpdate(channel.updated_at || channel.created_at)}
                        </span>

                        <button
                          onClick={(e) => handleOpenForwardModal(channel, e)}
                          className="ct-icon-btn ct-forward-icon"
                          title="Otomatik Paylaşım"
                        >
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M17 1l4 4-4 4" />
                            <path d="M3 11V9a4 4 0 014-4h14" />
                            <path d="M7 23l-4-4 4-4" />
                            <path d="M21 13v2a4 4 0 01-4 4H3" />
                          </svg>
                        </button>

                        <button
                          onClick={() => handleShowHistory(channel)}
                          className="ct-icon-btn ct-history-icon"
                          title="Geçmiş"
                        >
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10" />
                            <polyline points="12 6 12 12 16 14" />
                          </svg>
                        </button>

                        <button
                          onClick={() => handleEditChannel(channel)}
                          className="ct-icon-btn ct-edit-icon"
                          title="Düzenle"
                        >
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </div>

      <ChannelHistoryModal
        isOpen={showHistoryModal}
        onClose={() => {
          setShowHistoryModal(false);
          setSelectedChannelForHistory(null);
        }}
        channelId={selectedChannelForHistory?.id}
        channelName={selectedChannelForHistory?.name}
        BASE_URL={BASE_URL}
      />
      <ChannelForwardModal
        isOpen={showForwardModal}
        onClose={() => {
          setShowForwardModal(false);
          setSelectedChannelForForward(null);
        }}
        channel={selectedChannelForForward}
      />
    </div>
  );
};

export default TelegramChannels;